import { render, staticRenderFns } from "./font_awesome.vue?vue&type=template&id=65a02466&"
import script from "./font_awesome.vue?vue&type=script&lang=js&"
export * from "./font_awesome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports